import { ActionBasic } from 'kts-scaffold-framework/modules';
import ModulesState from './Modules.State';
import { connect, MyStore, reducers } from 'kts-platform-frame/redux';
import { createCompany, network, invite } from 'src/api';
import { history } from 'kts-platform-frame/routes';

class ModulesAction extends ActionBasic<ModulesState> {
    /** 检查ticket */
    public checkTicket = async (ticket) => {
        const res: any = await network.checkTicketVisible(this, { ticket: ticket });
        if (!res.er) {
            this.modulesState.info = res.res;
            this.modulesState.inviteCompanyName = res.res.inviterCompanyName;
            this.modulesState.imgUrl = res.res.inviterCompanyMainImage;
            this.modulesState.currentEmail = res.res.invitationEmail;
            this.modulesState.ticket = ticket;
            this.setModulesState();
        }
        this.setModulesState();   
    }
    /** 控制密码是否可见 */
    public handlePwdShow = () => {
        this.modulesState.ispwdOpen = !this.modulesState.ispwdOpen;
        this.setModulesState();
    }
    /** 是否同意用户协议 */
    public agree = (e) => {
        this.modulesState.isAgree = e.target.checked;
        this.setModulesState();
    }
    /** 注册公司，提交表单 */
    public activeCompany = async (opt) => {
        let data = { 
            adminEmail: opt.email,
            adminName: opt.nickName,
            adminPassWord: opt.pass,
            companyName: opt.companyName,
            companyTaxid: opt.taxId,
            ticket: this.modulesState.ticket 
        };
        const res = await network.registryNetworkCompany(this, data);
        if (!res.er) {
            this.onClickOutHandler();
            this.modulesState.success = true;
            this.setModulesState();
        }
    }
    /** 返回登陆页 */
    public go = (router) => {
        history.push(router);
    }

    /** 验证信息 */
    public registryInfoCheck = async (opt) => {
        const res = await network.registryInfoCheck(this, opt);
        if (!res.er) {
            return res.res;
        }
    }

    /** 退出登录 */
    private onClickOutHandler = () => {
        MyStore.instance.dispatch(reducers.user.ActionTypes.fnSetUserInfo, { gToken: null, cToken: null });
        // history.push('/login');
    }
    /** 改变邮箱的值 */
    public onChangeEmail = (e) => {
        this.modulesState.currentEmail = e.target.value;
    }

    /** input获取焦点 */
    public onInputFocus = (e) => {
        this.modulesState.inputState[e.target.id] = true;
        this.setModulesState();
    }
    /** input 失去焦点 */
    public onInputBlur = (e) => {
        this.modulesState.inputState[e.target.id] = e.target.value ? true : false;
        this.setModulesState();
    }
}

export default new ModulesAction();



// WEBPACK FOOTER //
// ./src/display/platform/Network/CompanyRegister/Modules.Action.ts